import * as React from 'react';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import { actionLogout } from '../../../store/authentication/action';

interface LogoutProps {
  logout: () => void;
}

class Logout extends React.Component<LogoutProps> {

  componentDidMount() {
    this.props.logout();
  }

  render() {
    return <Redirect to="/" />;
  }
}

// tslint:disable-next-line: no-any
const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    logout: () => dispatch(actionLogout()),
  };
};

export default connect(null, mapDispatchToProps)(Logout);
